import React from 'react';
import { Grid } from '@material-ui/core';

import '../styles/Footer.css';

import youtube from '../assets/youtube.png';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import twitter from '../assets/twitter.png';
import pin from '../assets/pin.png';

const Footer = () => {
  return (
    <div className="footer">
      <h2>Catergories</h2>
      {/* Footer Icons */}
      <div className="footer__iconrow">
        <Grid container spacing={1}>
          <Grid item xs>
            <div className="footer__comedie"></div>
          </Grid>
          <Grid item xs>
            <div className="footer__action"></div>
          </Grid>
          <Grid item xs>
            <div className="footer__drama"></div>
          </Grid>
          <Grid item xs>
            <div className="footer__romance"></div>
          </Grid>{' '}
          <Grid item xs>
            <div className="footer__sci-fi"></div>
          </Grid>
          <Grid item xs>
            <div className="footer__thriller"></div>
          </Grid>
        </Grid>
      </div>
      {/* Footer logoBar */}
      <div className="footer__logoDiv">
        <Grid container>
          <Grid item xs>
            <h1>Logo</h1>
            <div className="footer__socialiconsDiv">
              <img src={youtube} alt="Youtube" />{' '}
              <img src={facebook} alt="Facebook" />
              <img src={instagram} alt="Instagram" />{' '}
              <img src={twitter} alt="Twitter" />{' '}
              <img src={pin} alt="Pintrest" />{' '}
            </div>
          </Grid>
          <Grid item xs>
            <div className="footer__logoDiv2">
              <h3>LEGAL</h3>
              <p>About us</p>
              <p>Terms of use</p>
              <p>Privacy Policy</p>
              <p>Cntent Complaints</p>
            </div>
          </Grid>
          <Grid item xs>
            <h3>Support</h3>
            <p>FAQs</p>
            <p>Contact us</p>
          </Grid>
        </Grid>
      </div>
      {/* Footer Social_Icons */}
      <div className="footer__socialIcons">
        <h3>2020-2021 XYZ</h3>
      </div>
    </div>
  );
};

export default Footer;
